import React from "react";
import "./CallbackReminder.css";
import Button from "../Button/Button";
import { ReactComponent as CallbackReminderIcon } from "../../Assets/Images/callback-reminder-icon.svg";
import { ReactComponent as CalendarIcon } from "../../Assets/Images/callback-calender.svg";
import { ReactComponent as TimerIcon } from "../../Assets/Images/callback-timer.svg";
import { ReactComponent as TimerOffsetIcon } from "../../Assets/Images/callback-time-offset.svg";

function CallbackReminderDisplay({ reminder, isDarkMode, onEdit }) {
  const getOffsetLabel = (offset) => {
    if (!offset) return null;
    const unitMap = {
      m: "minute",
      h: "hour",
      d: "day",
    };
    const value = parseInt(offset);
    const unit = offset.slice(-1);
    const plural = value > 1 ? "s" : "";
    return `${value} ${unitMap[unit] || "minute"}${plural} before`;
  };
  const formatReminderTime = (callbackAt) => {
    const date = new Date(callbackAt);
    return {
      date: date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      }),
      time: date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
  };
  const { date, time } = formatReminderTime(reminder.callbackAt);
  const offsetLabel = getOffsetLabel(reminder.callbackReminderOffset);

  return (
    <div className={`callback-reminder-container${isDarkMode ? " dark" : ""}`}>
      <div className="callback-reminder-left">
        <div className="callback-reminder-icon-box">
          <CallbackReminderIcon />
        </div>

        <div className="callback-reminder-text-block">
          <span className="callback-reminder-title">Callback Reminder</span>
          <div className="callback-reminder-meta">
            <span className="callback-reminder-meta-item">
              <CalendarIcon />

              {date}
            </span>

            <span className="callback-reminder-dot">•</span>

            <span className="callback-reminder-meta-item">
              <TimerIcon />
              {time}
            </span>

            {offsetLabel && (
              <>
                <span className="callback-reminder-dot">•</span>
                <span className="callback-reminder-meta-item">
                  <TimerOffsetIcon />
                  {offsetLabel}
                </span>
              </>
            )}
          </div>
        </div>
      </div>

      <Button
        className="callback-reminder-edit-btn"
        event={onEdit}
        label={"Edit Reminder"}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      </Button>
    </div>
  );
}

export default CallbackReminderDisplay;
